import { MortgageLenderTypes } from "@nestoca/multi-tenant";

export type MortgageLenderType =
  (typeof MortgageLenderTypes)[keyof typeof MortgageLenderTypes];

export const MORTGAGE_LENDER_LABELS: Record<MortgageLenderType, string> = {
  [MortgageLenderTypes.RBC]: "common:lender.rbc",
  [MortgageLenderTypes.CIBC]: "common:lender.cibc",
  [MortgageLenderTypes.TD]: "common:lender.td",
  [MortgageLenderTypes.SCOTIABANK]: "common:lender.scotia",
  [MortgageLenderTypes.NATIONAL_BANK]: "common:lender.national_bank",
  [MortgageLenderTypes.DESJARDINS]: "common:lender.desjardins",
  [MortgageLenderTypes.BMO]: "common:lender.bmo",
  [MortgageLenderTypes.CANADA_LIFE]: "common:lender.canada_life",
  [MortgageLenderTypes.B2B_LAURENTIAN]: "common:lender.b2b_laurentian",
  [MortgageLenderTypes.LAURENTIAN]: "common:lender.laurentian",
  [MortgageLenderTypes.MCAP]: "common:lender.mcap",
  [MortgageLenderTypes.FIRST_NATIONAL]: "common:lender.first_national",
  [MortgageLenderTypes.EQUITABLE_BANK]: "common:lender.equitable_bank",
  [MortgageLenderTypes.STREET_CAPITAL]: "common:lender.street_capital",
  [MortgageLenderTypes.LENDWISE]: "common:lender.lendwise",
  [MortgageLenderTypes.MERIX]: "common:lender.merix",
  [MortgageLenderTypes.CMLS]: "common:lender.cmls",
  [MortgageLenderTypes.ALTERNA]: "common:lender.alterna",
  [MortgageLenderTypes.RADIUS_FINANCIAL]: "common:lender.radius_financial",
  [MortgageLenderTypes.DUCA]: "common:lender.duca",
  [MortgageLenderTypes.HOME_TRUST]: "common:lender.home_trust",
  [MortgageLenderTypes.ICICI_BANK]: "common:lender.icici_bank",
  [MortgageLenderTypes.INDUSTRIAL_ALLIANCE]:
    "common:lender.industrial_alliance",
  [MortgageLenderTypes.MANULIFE]: "common:lender.manulife",
  [MortgageLenderTypes.MEREDIAN]: "common:lender.meredian",
  [MortgageLenderTypes.OPTIMUM_MORTGAGE]: "common:lender.optimum_mortgage",
  [MortgageLenderTypes.PC_FINANCIALS]: "common:lender.pc_financials",
  [MortgageLenderTypes.TANGERINE]: "common:lender.tangerine",
  [MortgageLenderTypes.PRIVATE]: "common:lender.private",
  [MortgageLenderTypes.OTHER]: "common:lender.other",
  [MortgageLenderTypes.IG]: "common:lender.ig",
  [MortgageLenderTypes.NESTO]: "common:lender.nesto",
  [MortgageLenderTypes.SOLUTIONS_BANKING]: "common:lender.solutions_banking",
  [MortgageLenderTypes.ALBERTA_TREASURY_BRANCHES]:
    "common:lender.alberta_treasury_branches",
  [MortgageLenderTypes.CAISSE_POPULAIRE_CREDIT_UNIONS]:
    "common:lender.caisse_populaire_credit_unions",
  [MortgageLenderTypes.CITIZENS_BANK]: "common:lender.citizens_bank",
  [MortgageLenderTypes.COASTAL_CAPITAL]: "common:lender.coastal_capital",
  [MortgageLenderTypes.DUNDEE_BANK_OF_CANADA]:
    "common:lender.dundee_bank_of_canada",
  [MortgageLenderTypes.FIRSTLINE_MORTGAGES]:
    "common:lender.firstline_mortgages",
  [MortgageLenderTypes.HOME_EQUITY_BANK]: "common:lender.home_equity_bank",
  [MortgageLenderTypes.HSBC_BANK_OF_CANADA]: "common:lender.hsbc",
  [MortgageLenderTypes.QUESTRADE]: "common:lender.quest_trade",
  [MortgageLenderTypes.SUNLIFE_FINANCIAL]: "common:lender.sunlife",
  [MortgageLenderTypes.VANCITY]: "common:lender.vancity",
};

export enum LenderEnum {
  ALTERNA = "ALTERNA",
  B2B_LAURENTIAN = "B2B_LAURENTIAN",
  BMO = "BMO",
  CIBC = "CIBC",
  CMLS = "CMLS",
  DESJARDINS = "DESJARDINS",
  DUCA = "DUCA",
  EQUITABLE_BANK = "EQUITABLE_BANK",
  FIRST_NATIONAL = "FIRST_NATIONAL",
  HOME_TRUST = "HOME_TRUST",
  ICICI_BANK = "ICICI_BANK",
  IG = "IG",
  INDUSTRIAL_ALLIANCE = "INDUSTRIAL_ALLIANCE",
  LAURENTIAN = "LAURENTIAN",
  LENDWISE = "LENDWISE",
  MANULIFE = "MANULIFE",
  MEREDIAN = "MEREDIAN",
  MERIX = "MERIX",
  MCAP = "MCAP",
  NATIONAL_BANK = "NATIONAL_BANK",
  OPTIMUM_MORTGAGE = "OPTIMUM_MORTGAGE",
  PC_FINANCIALS = "PC_FINANCIALS",
  RADIUS_FINANCIAL = "RADIUS_FINANCIAL",
  RBC = "RBC",
  SCOTIABANK = "SCOTIABANK",
  STREET_CAPITAL = "STREET_CAPITAL",
  TANGERINE = "TANGERINE",
  TD = "TD",
  SOLUTIONS_BANKING = "SOLUTIONS_BANKING",
  PRIVATE = "PRIVATE",
  OTHER = "OTHER",
  ALBERTA_TREASURY_BRANCHES = "ALBERTA_TREASURY_BRANCHES",
  CAISSE_POPULAIRE_CREDIT_UNIONS = "CAISSE_POPULAIRE_CREDIT_UNIONS",
  HSBC_BANK_OF_CANADA = "HSBC_BANK_OF_CANADA",
  CITIZENS_BANK = "CITIZENS_BANK",
  COASTAL_CAPITAL = "COASTAL_CAPITAL",
  DUNDEE_BANK_OF_CANADA = "DUNDEE_BANK_OF_CANADA",
  FIRSTLINE_MORTGAGES = "FIRSTLINE_MORTGAGES",
  HOME_EQUITY_BANK = "HOME_EQUITY_BANK",
  QUESTRADE = "QUESTRADE",
  SUNLIFE_FINANCIAL = "SUNLIFE_FINANCIAL",
  VANCITY = "VANCITY",
}

export const LENDERS = Object.entries(LenderEnum).map(([key, value]) => ({
  label: `common:lender.${key.toLowerCase()}`,
  value,
}));

export { sortLenderOptions } from "./sort-lender-options";
